module.exports = __webpack_public_path__ + "img/取信01.4848fc9b.svg";